export const TICKET_COST_CLIENT = 82;
export const TICKET_COST_ENT = 129;
export const TICKET_COST_HES = 360;
export const TICKET_COST_IMAC = 360; // full day
export const FE_COST_PER_DAY = 240;
export const VEHICLE_COST_PER_DAY = 20;
export const VEHICLE_COST_PER_KILOMETER = 0.4;
export const PUDO_VISIT_COST = 7.5;
export const OVERTIME_COST_PER_HOUR = 51.45;
export const PARTNER_FE_COST_PER_TICKET = 60;
